import { useEffect, useRef } from "react";

export default function useOfflineIdle(isOnline, onIdle, timeout = 300000) {
  const timer = useRef(null);

  useEffect(() => {
    if (isOnline) return; 

    const resetTimer = () => {
      if (timer.current) clearTimeout(timer.current);

      timer.current = setTimeout(() => {
        onIdle();
      }, timeout);
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach(e => window.addEventListener(e, resetTimer));

    resetTimer(); 

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      clearTimeout(timer.current);
    };
  }, [isOnline, onIdle, timeout]);
}
